import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatBadgeModule } from '@angular/material/badge';
import { TranslateModule } from '@ngx-translate/core';
import { HeaderButtonComponent } from './header-button/header-button.component';

@Component({
  selector: 'app-notification-button',
  standalone: true,
  imports: [CommonModule, MatIconModule, MatBadgeModule, TranslateModule, HeaderButtonComponent],
  template: `
    <app-header-button
      caption="{{ 'shared.notifications' | translate }}"
      icon="notifications_icon"
      [badgeCount]="notificationCount"
      (buttonClick)="onclick.emit($event)"
    />
  `,
  styles: [],
})
export class NotificationButtonComponent {
  @Input() isSmall?: boolean;
  @Input() notificationCount = 0;
  @Output() onclick = new EventEmitter<Event>();
}
